<app-menu-riot></app-menu-riot>
<div class="container">
    <img src="https://playforgood.io/wp-content/uploads/2021/05/Play-For-Good-2_Manifeste-724x1024.jpg" alt="manifeste-play-for-good">
</div>
<app-scroll-to-top></app-scroll-to-top>
<app-footer></app-footer>
